import React, { useEffect } from 'react';
import {useQueryString} from "../../../hooks/useQueryString";
import readConfig from "../../../utils/readClientConfiguration";
import productionConfiguration from "../../../../config/default.json";


const ProductQuestions = () => {
    const { getQueryStringParam } = useQueryString();
    const formConfig = readConfig(productionConfiguration, 'forms');

    useEffect(() => {
        const inputName = document.getElementById(formConfig.inputNameId);
        const inputSku = document.getElementById(formConfig.inputSkuId);
        if (inputName && inputSku) {
            inputName.value = getQueryStringParam('productName');
            inputSku.value = getQueryStringParam('productSku');
        }
    });

    return <></>;
};


export default ProductQuestions;
